/***
 *
 *   STATUS WORKFLOW BOARD
 *   Drag statuses between template buckets. Auto-PATCHes on cross-column drop.
 *
 **********/

import React, { useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Column from './column';
import Style from './board.tailwind';

const onDragEnd = (result, columns, setColumns, updateTicketStatusMutation, setDragInfo) => {
    setDragInfo({});
    if (!result.destination) return;

    const { source, destination } = result;

    const newColumns = columns.map((column) => ({
        ...column,
        statuses: [...column.statuses],
    }));

    const sourceIndex = newColumns.findIndex((column) => column.key === source.droppableId);
    const destinationIndex = newColumns.findIndex(
        (column) => column.key === destination.droppableId,
    );

    if (sourceIndex < 0 || destinationIndex < 0) return;

    if (source.droppableId !== destination.droppableId) {
        const [removed] = newColumns[sourceIndex].statuses.splice(source.index, 1);
        newColumns[destinationIndex].statuses.splice(destination.index, 0, removed);
        updateTicketStatusMutation.mutate({ status_template: newColumns });
    } else {
        const [removed] = newColumns[sourceIndex].statuses.splice(source.index, 1);
        newColumns[sourceIndex].statuses.splice(destination.index, 0, removed);
    }

    setColumns(newColumns);
};

export const Board = ({ statusTemplate, updateTicketStatusMutation }) => {
    const [columns, setColumns] = useState(statusTemplate);
    const [dragInfo, setDragInfo] = useState({});

    useEffect(() => {
        setColumns(statusTemplate);
    }, [statusTemplate]);

    const handleDragUpdate = (update) => {
        if (update.destination) {
            setDragInfo({
                from: update.source.droppableId,
                to: update.destination.droppableId,
            });
        }
    };

    const unassigned = columns.find((c) => c.key === 'unassigned');
    const buckets = columns.filter((c) => c.key !== 'unassigned' && !c.hidden);
    const showUnassigned = (unassigned?.statuses?.length || 0) > 0;

    return (
        <DragDropContext
            onDragEnd={(result) =>
                onDragEnd(result, columns, setColumns, updateTicketStatusMutation, setDragInfo)
            }
            onDragUpdate={handleDragUpdate}>
            <div className={Style.stack}>
                {showUnassigned && unassigned && (
                    <Column
                        columnId={unassigned.key}
                        column={unassigned}
                        updateTicketStatusMutation={updateTicketStatusMutation}
                        statusTemplate={columns}
                        dragInfo={dragInfo}
                        layout="strip"
                    />
                )}

                <div className={Style.grid}>
                    {buckets.map((column) => (
                        <Column
                            key={column.key}
                            columnId={column.key}
                            column={column}
                            updateTicketStatusMutation={updateTicketStatusMutation}
                            statusTemplate={columns}
                            dragInfo={dragInfo}
                            layout="bucket"
                        />
                    ))}
                </div>
            </div>
        </DragDropContext>
    );
};
